import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import api from 'utils/api';
import { useProviderStore } from 'Store/ProviderStore';
import { toast } from 'react-hot-toast'; // فرض بر این است که از این کتابخانه استفاده می‌کنید

const EmployeeManagement = (selectedProvider) => {
  // ... (State definitions remain the same)
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const provider = useProviderStore((state) => state.provider);

  const [serviceOptions, setServiceOptions] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    services: [],
    workDays: [],
    startTime: '09:00',
    endTime: '18:00',
  });

  useEffect(() => {
    fetchEmployees();
    getServices();
  }, [selectedProvider, provider._id]);

  const getServices = async () => {
    try {
      const response = await api.get(`/providers/${provider._id}/services`);
      setServiceOptions(response.data);
    } catch (error) {
      console.error('Error fetching services:', error);
    }
  };

  const fetchEmployees = async () => {
    try {
      const { data } = await api.get(`/providers/${provider._id}/employees`);
      setEmployees(data);
      setFilteredEmployees(data);
    } catch (error) {
      console.error('Error fetching employees:', error);
    }
  };

  const workDayOptions = [
    { value: 'saturday', label: 'شنبه' },
    { value: 'sunday', label: 'یکشنبه' },
    { value: 'monday', label: 'دوشنبه' },
    { value: 'tuesday', label: 'سه‌شنبه' },
    { value: 'wednesday', label: 'چهارشنبه' },
    { value: 'thursday', label: 'پنج‌شنبه' },
    { value: 'friday', label: 'جمعه' },
  ];

  // ---------------------------------------------------------
  // 1. اصلاح تابع ارسال فرم برای ساخت ساختار workSchedule
  // ---------------------------------------------------------
  const handleFormSubmit = async (e) => {
    e?.preventDefault();

    // تبدیل روزهای انتخاب شده و ساعت کلی به فرمت مورد نیاز دیتابیس
    const workSchedule = formData.workDays.map((day) => ({
      day: day,
      startTime: formData.startTime,
      endTime: formData.endTime,
    }));

    const payload = {
      name: formData.name,
      phone: formData.phone,
      email: formData.email,
      services: formData.services,
      workSchedule: workSchedule, // ارسال آرایه زمان‌بندی به جای workDays
      // نکته: workDays و workTime را دیگر ارسال نمی‌کنیم چون در مدل نیستند
    };

    try {
      if (showAddModal) {
        await api.post(`/providers/${provider._id}/employees`, payload);
      } else if (showEditModal && selectedEmployee?._id) {
        await api.put(
          `/providers/${provider._id}/employees/${selectedEmployee._id}`,
          payload
        );
      }

      await fetchEmployees();
      setShowAddModal(false);
      setShowEditModal(false);
      setSelectedEmployee(null);
      toast.success('کارمند با موفقیت ذخیره شد!');
    } catch (error) {
      console.error('Error saving employee:', error);
      toast.error('خطا در ذخیره اطلاعات');
    }
  };

  const handleAddEmployee = () => {
    setFormData({
      name: '',
      phone: '',
      email: '',
      services: [],
      workDays: [],
      startTime: '09:00',
      endTime: '18:00',
    });
    setShowAddModal(true);
  };

  const normalizedServiceOptions = serviceOptions.map((s) => ({
    value: s._id,
    label: s.name,
  }));

  // ---------------------------------------------------------
  // 2. اصلاح تابع ویرایش برای بازگرداندن اطلاعات از workSchedule به فرم
  // ---------------------------------------------------------
  const handleEditEmployee = (employee) => {
    setSelectedEmployee(employee);

    // استخراج روزها از workSchedule
    const currentWorkDays =
      employee.workSchedule?.map((schedule) => schedule.day) || [];

    // استخراج ساعت (فرض بر این است که ساعت همه روزها یکسان است، پس از اولین آیتم برمی‌داریم)
    const currentStartTime = employee.workSchedule?.[0]?.startTime || '09:00';
    const currentEndTime = employee.workSchedule?.[0]?.endTime || '18:00';

    setFormData({
      name: employee?.name,
      phone: employee?.phone,
      email: employee?.email,
      services: employee?.services?.map((service) =>
        typeof service === 'object' ? service._id : service
      ),
      workDays: currentWorkDays,
      startTime: currentStartTime,
      endTime: currentEndTime,
    });

    setShowEditModal(true);
  };

  const handleDeleteEmployee = async (selectedEmployee) => {
    try {
      await api.delete(
        `/providers/${provider._id}/employees/${selectedEmployee._id}`
      );
      toast.success('کارمند با موفقیت حذف شد');
      await fetchEmployees(); // رفرش لیست
    } catch (err) {
      console.log(err);
      toast.error('خطا در حذف کارمند');
    }
    setShowDeleteModal(false); // بستن مودال
  };

  // ---------------------------------------------------------
  // 3. توابع کمکی برای نمایش در جدول
  // ---------------------------------------------------------

  // تبدیل روزهای انگلیسی دیتابیس به فارسی برای نمایش
  const getPersianDays = (schedule) => {
    if (!schedule || schedule.length === 0) return '-';
    const dayMap = {
      saturday: 'شنبه',
      sunday: 'یکشنبه',
      monday: 'دوشنبه',
      tuesday: 'سه‌شنبه',
      wednesday: 'چهارشنبه',
      thursday: 'پنج‌شنبه',
      friday: 'جمعه',
    };
    return schedule.map((s) => dayMap[s.day] || s.day).join('، ');
  };

  // نمایش ساعت کاری از روی اولین آیتم
  const getWorkTimeDisplay = (schedule) => {
    if (!schedule || schedule.length === 0) return '-';
    return `${schedule[0].startTime} - ${schedule[0].endTime}`;
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': // تغییر طبق مدل (active/inactive)
      case 'فعال':
        return 'text-success bg-success/10';
      case 'inactive':
      case 'غیرفعال':
        return 'text-muted-foreground bg-muted';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center">
        <div>
          <h2 className="text-xl font-semibold text-foreground">
            مدیریت کارکنان
          </h2>
          <p className="text-sm text-muted-foreground mt-1">
            مدیریت اطلاعات و برنامه کاری کارکنان خدمات دهنده
          </p>
        </div>
        <Button
          variant="default"
          onClick={handleAddEmployee}
          iconName="Plus"
          iconPosition="right">
          افزودن کارمند جدید
        </Button>
      </div>

      <div className="hidden lg:block bg-card border border-border rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-muted/50 border-b border-border">
              <tr>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  کارمند
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  اطلاعات تماس
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  خدمات
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  روزهای کاری
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  ساعات کاری
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  وضعیت
                </th>
                <th className="text-center px-6 py-4 text-sm font-medium text-foreground">
                  عملیات
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {filteredEmployees?.map((employee) => (
                <tr
                  key={employee?._id}
                  className="hover:bg-muted/30 transition-colors duration-150">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full overflow-hidden bg-muted">
                        <img
                          src={
                            employee?.avatar ||
                            'https://i.ibb.co/JW1sG7MT/avatar.png'
                          }
                          alt={employee?.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground">
                          {employee?.name}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="space-y-1">
                      <p className="text-sm text-foreground">
                        {employee?.phone}
                      </p>
                      <p className="text-xs text-muted-foreground">
                        {employee?.email}
                      </p>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex flex-wrap gap-1">
                      {employee?.services?.slice(0, 2).map((service, index) => (
                        <span
                          key={index}
                          className="inline-block px-2 py-1 text-xs bg-primary/10 text-primary rounded-md">
                          {typeof service === 'object'
                            ? service?.name
                            : service}
                        </span>
                      ))}
                    </div>
                  </td>
                  {/* اصلاح نمایش روزهای کاری */}
                  <td className="px-6 py-4">
                    <p className="text-sm text-foreground">
                      {getPersianDays(employee?.workSchedule)}
                    </p>
                  </td>
                  {/* اصلاح نمایش ساعات کاری */}
                  <td className="px-6 py-4">
                    <p className="text-sm text-foreground">
                      {getWorkTimeDisplay(employee?.workSchedule)}
                    </p>
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`inline-block px-2 py-1 text-xs rounded-md ${getStatusColor(
                        employee?.status
                      )}`}>
                      {employee?.status === 'active' ? 'فعال' : 'غیرفعال'}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center justify-center gap-2">
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleEditEmployee(employee)}
                        iconName="Edit"
                        iconSize={16}
                      />
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => {
                          setSelectedEmployee(employee);
                          setShowDeleteModal(true);
                        }}
                        iconName="Trash2"
                        iconSize={16}
                        className="text-error hover:text-error"
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* بخش نمایش موبایل هم باید مشابه جدول به‌روزرسانی شود */}
      <div className="lg:hidden space-y-4">
        {filteredEmployees?.map((employee) => (
          <div
            key={employee?._id}
            className="bg-card border border-border rounded-lg p-4">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                {/* ... بخش آواتار مشابه قبل ... */}
                <div>
                  <h3 className="text-sm font-medium text-foreground">
                    {employee?.name}
                  </h3>
                </div>
              </div>
            </div>
            <div className="space-y-2 mb-4">
              {/* ... خدمات مشابه قبل ... */}
              <div>
                <p className="text-xs text-muted-foreground">
                  روزهای کاری: {getPersianDays(employee?.workSchedule)}
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  ساعات کاری: {getWorkTimeDisplay(employee?.workSchedule)}
                </p>
              </div>
            </div>
            {/* ... دکمه‌ها مشابه قبل ... */}
          </div>
        ))}
      </div>

      {/* Modal Add/Edit */}
      {(showAddModal || showEditModal) && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-modal z-modal flex items-center justify-center p-4">
          <div className="bg-popover border border-border rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto animate-scale-in">
            <div className="p-6">
              {/* ... Header Modal ... */}
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-foreground">
                  {showAddModal
                    ? 'افزودن کارمند جدید'
                    : 'ویرایش اطلاعات کارمند'}
                </h3>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => {
                    setShowAddModal(false);
                    setShowEditModal(false);
                  }}
                  iconName="X"
                  iconSize={20}
                />
              </div>

              <form onSubmit={handleFormSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label="نام و نام خانوادگی"
                    type="text"
                    value={formData?.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e?.target?.value })
                    }
                    required
                  />
                  <Input
                    label="شماره تلفن"
                    type="tel"
                    value={formData?.phone}
                    onChange={(e) =>
                      setFormData({ ...formData, phone: e?.target?.value })
                    }
                    required
                  />
                </div>
                <Input
                  label="آدرس ایمیل"
                  type="email"
                  value={formData?.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e?.target?.value })
                  }
                />

                <Select
                  label="خدمات ارائه شده"
                  options={normalizedServiceOptions}
                  value={formData?.services}
                  onChange={(value) =>
                    setFormData({ ...formData, services: value })
                  }
                  multiple
                  searchable
                  required
                />

                <Select
                  label="روزهای کاری"
                  description="روزهایی که این کارمند در دسترس است"
                  options={workDayOptions}
                  value={formData?.workDays}
                  onChange={(value) =>
                    setFormData({ ...formData, workDays: value })
                  }
                  multiple
                  required
                />

                <div className="grid grid-cols-2 gap-4">
                  <Input
                    label="ساعت شروع کار"
                    type="time"
                    value={formData?.startTime}
                    onChange={(e) =>
                      setFormData({ ...formData, startTime: e?.target?.value })
                    }
                    required
                  />
                  <Input
                    label="ساعت پایان کار"
                    type="time"
                    value={formData?.endTime}
                    onChange={(e) =>
                      setFormData({ ...formData, endTime: e?.target?.value })
                    }
                    required
                  />
                </div>

                <div className="flex gap-3 pt-4">
                  <Button type="submit" variant="default" className="flex-1">
                    {showAddModal ? 'افزودن کارمند' : 'ذخیره تغییرات'}
                  </Button>
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => {
                      setShowAddModal(false);
                      setShowEditModal(false);
                    }}
                    className="flex-1">
                    انصراف
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal (بدون تغییر منطقی خاص، فقط فیکس کردن باگ‌های احتمالی) */}
      {showDeleteModal && selectedEmployee && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-modal z-modal flex items-center justify-center p-4">
          <div className="bg-popover border border-border rounded-lg w-full max-w-md animate-scale-in">
            <div className="p-6">
              <p>آیا از حذف {selectedEmployee.name} اطمینان دارید؟</p>
              <div className="flex gap-3 mt-4">
                <Button
                  variant="destructive"
                  onClick={() => handleDeleteEmployee(selectedEmployee)}
                  className="flex-1">
                  حذف
                </Button>
                <Button
                  variant="outline"
                  onClick={() => setShowDeleteModal(false)}
                  className="flex-1">
                  انصراف
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployeeManagement;
